import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  // R4-FEC-010 fix: initialize to `false` (mobile-first SSR default) instead
  // of `undefined` to avoid hydration mismatch. The server renders with
  // `isMobile = false`; the client's useEffect sets the real value on mount.
  // This produces a brief flash where the desktop layout is shown on mobile
  // until the effect fires, but avoids the React hydration warning.
  // Known limitation: the first render on the client will always use `false`
  // until the media query listener runs. If this is unacceptable, wrap
  // the consuming element with `suppressHydrationWarning`.
  const [isMobile, setIsMobile] = React.useState<boolean>(false)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return isMobile
}
